// extracted by mini-css-extract-plugin
module.exports = {"black":"#384241","darkGray":"#737a7a","mediumGray":"#afb3b3","lightGray":"#ebecec","offWhite":"#f9f9f9","white":"#fff","success":"#19a413","error":"#d63649","warning":"#f7c137"};